import { FieldType, FormlyFieldConfig } from "@ngx-formly/core";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { SearchService } from "../providers/search-service/search-service";
import { AppService } from "../app.service";
import { ActionService } from "../services/action/action.service";
import { AddContractorComponent } from "../components/bog_tour/add-contractor/add-contractor.component";
import { Component, OnInit, ChangeDetectorRef, NgZone } from "@angular/core";
import * as moment from "moment";
import {
  InfiniteScrollCustomEvent,
  ModalController,
  NavController,
  PopoverController,
} from "@ionic/angular";
import { Item } from "firebase/analytics";
import { FormGroup } from "@angular/forms";
import { AppConstants } from "../providers/constants/app-constants.service";
import { BaseInjectorService } from "../base/base-service.injector";
import { LhStorageService } from "@hssa-itasia/ngx-util-core";
import { RapidtourService } from "../services/rapid-tour/rapidtour.service";
import { IDiscussedUserListComponent } from "./rapid-component/i-discussed-user-list/i-discussed-user-list.component";
import * as _ from "lodash";
import { VpcHazService } from "../pages/vpc-haz/vpc-haz.service";
import { AssignedToModalPage } from "../pages/assigned-to-modal/assigned-to-modal.page";
import { SearchUsersComponent } from "./search-users/search-users.component";

@Component({
  selector: "assigned-to-add-action",
  styles: [
    `
      .without_email_ {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .user_name {
        display: block;
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        opacity: 1;
      }
      .user_email {
        display: block;
        word-break: break-all;
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.38px;
        color: #000000;
        opacity: 1;
      }
      .textBox {
        max-width: 100%;
        width: 100%;
        margin-top: 10px;
      }
      .mandatory {
        color: red;
        font-size: 15px;
      }
      .UserRow {
        display: flex;
        margin-top: 5px;
      }
      .userNameCol {
        display: grid;
        position: relative;
      }

      .userphotoList_col {
        max-width: 45px;
      }
      .userInfoList_col {
        padding-top: 7px !important;
      }
      .userselecttion_col {
        max-width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .emailCss {
        font-size: 12px;
        display: block;
        position: relative;
        margin-top: 2px;
        text-align: left;
        letter-spacing: 0.38px;
        color: #000000;
        opacity: 1;
      }
      .unselected_css {
        height: 20px;
        width: 20px;
        float: right;
        margin-top: 11px;
        border: 1px solid var(--ion-Teal-color);
        border-radius: 4px;
      }
      .selected_css {
        height: 21px;
        width: 21px;
        float: right;
        margin-top: 11px;
        border-radius: 4px;
        background-color: var(--ion-Teal-color);
        text-align: center;
        ion-icon {
          color: var(--ion-white-color);
          font-size: 19px;
          margin-bottom: 4px;
        }
      }
      .dummyUser_css {
        border-radius: 50%;
        overflow: hidden;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        width: 40px;
        margin-left: -4px;
      }
      .nameCss {
        font-size: 16px;
        display: block;
        position: relative;
        text-align: left;
        letter-spacing: 0.51px;
        color: #000000;
        opacity: 1;
      }
      .searchList_Div {
        height: 100px;
        color: #000;
      }
      .emp_type {
        border-radius: 4px;
        opacity: 1;
        padding: 5px;
        word-break: break-all;
        font-size: 12px;
      }
      .employee_css {
        background: #d6f4f1 0% 0% no-repeat padding-box;
        color: #007382;
      }
      .contractor_css {
        background: #c6f2ff 0% 0% no-repeat padding-box;
        color: #2674d1;
      }
      .not_found_css {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        font-weight: 100;
      }
      .searchUser_css {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        font-weight: bold;
        margin-left: 5px;
      }
      .addContractor_btn_css {
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        height: 40px;
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #017180;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 5px;
      }
      .no_display_css {
        display: none;
      }
      .display_css {
        display: block;
        position: relative;
      }
      .email_col {
        display: flex;
        vertical-align: middle;
        position: relative;
        margin: 0 auto;
      }
      .email_col_div {
        display: block;
      }
      .search_icon {
        color: #007382;
        font-size: 25px;
        margin-right: 10px;
      }
      .notes_div {
        width: 27px;
        height: 27px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #027382;
        border-radius: 6px;
        opacity: 1;
      }
      .notes_col {
        width: 36px;
        max-width: 36px;
      }
      .notes_icon {
        font-size: 20px;
        color: var(--ion-color-secondary);
      }
      .user_type_span {
        padding: 1px 4px;
        font-size: 16px;
        border-radius: 2px;
      }

      .cancelBtn {
        height: 48px;
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        background: #fff;
        padding: 0 30px;
        color: #017180;
      }
      .saveBtn {
        height: 48px;
        background: #027382;
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        padding: 0 30px;
        color: #fff;
      }
      .add_action_btn_col {
        display: flex;
        justify-content: right;
      }
      .description_div {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.15px;
        color: #000000;
        opacity: 1;
      }
      .description_date_div {
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.38px;
        color: #000000ab;
        opacity: 1;
      }
      .close_icon {
        font-size: 20px;
        color: #000;
        font-weight: bold;
      }
      .close_icon_col {
        max-width: 40px;
        width: 40px;
      }
      .selected_user_row {
        border-radius: 10px;
        display: block;
        border: 1px solid #007382;
        margin-bottom: 5px;
      }
      .disableBtn {
        pointer-events: none;
        opacity: 0.4;
      }

      .full-width {
        width: 100%;
      }

      .chip-input {
        display: inline-flex;
        align-items: center;
        background: #f2f2f2;
        border-radius: 20px;
        padding: 4px 10px;
        gap: 6px;
        min-height: 32px;
        cursor: pointer;
      }

      .chip-input .name {
        font-size: 14px;
        font-weight: 500;
      }

      .recommended-chip {
        background: #555;
        color: #fff;
        border-radius: 12px;
        padding: 2px 8px;
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
      }

      .close-icon {
        font-size: 16px;
        cursor: pointer;
      }

      .visibleHide {
        visibility: hidden;
        position: absolute;
      }

      .my-custom-card {
        border-radius: 7px;
        margin: 0px !important;
        padding: 0px !important;
        display: block;
        position: relative;
      }
    `,
  ],
  template: `
    <div>
      <ion-row>
        <ion-col>
          <mat-form-field
            appearance="outline"
            class="textBox full-width"
            (click)="openAssignedToListComponent()"
          >
            <mat-label>Assign to</mat-label>

            <!-- Invisible input just to keep label floating -->
            <input
              class="visibleHide"
              matInput
              [value]="
                actionService.action_AreaOwner?.Full_Name
                  ? actionService.action_AreaOwner.Full_Name
                  : ''
              "
              readonly
              hidden
            />

            <!-- Custom chip-style content -->
            <div
              class="chip-input"
              *ngIf="(actionService.action_AreaOwner?.Full_Name || localAreaOwner?.Full_Name)"
            >
              <span class="name">{{
                actionService.action_AreaOwner?.Full_Name || localAreaOwner?.Full_Name
              }}</span>
              <span *ngIf="!isSelected" class="recommended-chip"
                >Recommended</span
              >
            </div>

            <ion-icon matSuffix class="search_icon" name="search-outline" />
          </mat-form-field>
        </ion-col>
      </ion-row>
    </div>
  `,
  standalone: false
})
export class assignedToAddAction extends FieldType {
  searchListHeight: string = "100px";
  isSelected: boolean = false;
  isDescriptionSave: boolean = false;
  placeHolder: any;
  level: string = "immediate_risk";
  userEdit: boolean = true;
  copyUserList: any = [];
  siteManager: any = {};
  searchUser: string = "";
  searchUsersList: any[] = [];
  areaOwner: any = null;
  fromPage:any;
  // Add a local property to force template updates
  localAreaOwner: any = null;

  areaOwnerInfo: any = {
    full_name_lower: "",
    Email: "",
    Full_Name: "",
    First_Name: "",
    Last_Name: "",
    assignedTo: "",
    assignedToName: "",
    assignedToPersonUniqueId: "",
  };

  selected_users: any[] = [];

  constructor(
    public vpcHazService: VpcHazService,
    public ngZone: NgZone,
    private rapidService: RapidtourService,
    private changeDetection: ChangeDetectorRef,
    private modal: ModalController,
    private searchService: SearchService,
    private appService: AppService,
    private lhStorage: LhStorageService,
    public actionService: ActionService
  ) {
    super();
  }
  intiliazeDate() {
    console.log("props.category", this.props.category);
    if (this.isSelected) {
    } else {
      if (this.actionService.editActionMode == "edit") {
        // When editing existing action, hide "Recommended" tag
        this.isSelected = true;

        // this.areaOwnerInfo.full_name_lower =
        //   this.actionService.selectedEditActionVal.assigned_to_name.toLowerCase();
        this.areaOwnerInfo.Email =
          this.actionService.selectedEditActionVal.assignedTo;
        this.areaOwnerInfo.Full_Name =
          this.actionService.selectedEditActionVal.assigned_to_name;
        this.areaOwnerInfo.First_Name =
          this.actionService.selectedEditActionVal.assigned_to_name.split(
            " "
          )[0];
        this.areaOwnerInfo.Last_Name =
          this.actionService.selectedEditActionVal.assigned_to_name.split(
            " "
          )[1];
        this.areaOwnerInfo.assignedTo =
          this.actionService.selectedEditActionVal.assignedTo;
        this.areaOwnerInfo.assignedToName =
          this.actionService.selectedEditActionVal.assigned_to_name;
        this.areaOwnerInfo.assignedToPersonUniqueId =
          this.actionService.selectedEditActionVal.assigned_to_person_unique_id;
        this.actionService.action_AreaOwner = this.areaOwnerInfo;

        // this.formControl.setValue(this.actionService.action_AreaOwner.Email);
        // this.changeDetection.detectChanges();
      } else {
        // this.areaOwnerInfo.full_name_lower =
        //   this.appService.currentTour.currentBogTourInfo.area_owner.toLowerCase();
        // this.areaOwnerInfo.Email =
        //   this.appService.currentTour.currentBogTourInfo.area_owner_email;
        // this.areaOwnerInfo.Full_Name =
        //   this.appService.currentTour.currentBogTourInfo.area_owner;
        // this.areaOwnerInfo.First_Name =
        //   this.appService.currentTour.currentBogTourInfo.area_owner.split(
        //     " "
        //   )[0];
        // this.areaOwnerInfo.Last_Name =
        //   this.appService.currentTour.currentBogTourInfo.area_owner.split(
        //     " "
        //   )[1];
        // this.areaOwnerInfo.assignedTo =
        //   this.appService.currentTour.currentBogTourInfo.area_owner_email;
        // this.areaOwnerInfo.assignedToName =
        //   this.appService.currentTour.currentBogTourInfo.area_owner;
        // let filteredAssignedTo = _.filter(this.appService.appData.usersByCountry, (u) => {
        //   // console.log("🚀 ~ ActionService ~ filteredAssignedTo ~ u:", u)
        //   return u.email == this.appService.currentTour.currentBogTourInfo.area_owner;
        // });
        // if (filteredAssignedTo.length > 0) {
        //   this.areaOwnerInfo.assignedToPersonUniqueId = filteredAssignedTo[0].person_unique_id;
        // }
        //this.actionService.action_AreaOwner = this.areaOwnerInfo;

        // this.formControl.setValue(this.actionService.action_AreaOwner.Email);
        // this.changeDetection.detectChanges();
      }

      if (this.actionService.action_AreaOwner?.Email) {
        this.ngZone.run(() => {
          console.log("this.actionService.action_AreaOwner", this.actionService.action_AreaOwner)
          this.formControl.setValue(this.actionService.action_AreaOwner.Email);
          this.formControl.markAsTouched();
          this.formControl.markAsDirty();
          this.formControl.updateValueAndValidity({ emitEvent: true });

          // ✅ Also trigger parent form update manually
          this.form.updateValueAndValidity({ emitEvent: true });

          this.changeDetection.detectChanges();
        });
      }

      // if (this.actionService.action_AreaOwner?.Email) {
      //   // this.formControl.setValue(this.actionService.action_AreaOwner.Email);
      //   this.ngZone.run(() => {
      //     this.formControl.markAsTouched();
      //     this.formControl.updateValueAndValidity();
      //     this.changeDetection.detectChanges();
      //   });
      // }
    }
  }

  ngAfterViewInit() {
    setTimeout(() => this.intiliazeDate(), 700);
  }
  isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
  }
  async openAssignedToListComponent() {
    let zoneOwner:any;

    if(!this.isEmpty(this.appService.currentTour)){
      zoneOwner=this.appService.appData.configuredZone.find(item=>item.id===this.appService.currentTour.currentBogTourInfo.zone);
      this.appService.currentTour.currentBogTourInfo.zoneConfiguration=zoneOwner
    }
    //   if(find){
  //     zoneOwner=find;
  //   }
  // console.log("zoneConfiguration=",this.appService.currentTour.currentBogTourInfo);
    const modal = await this.modal.create({
      component: IDiscussedUserListComponent,
      // Use a new, dedicated CSS class for this modal's style
      cssClass: "half-page-modal",
      backdropDismiss: false,
      componentProps: {
        site_manager: this.appService.appData.site_manager_info[0],
        //area_owner: this.areaOwnerInfo,
        area_owner:zoneOwner,
        // Pass callback function to handle searchUserLists call specifically for this component
        onSearchUserLists: () => {
          this.searchUserLists();
        },
        // Add a context identifier to distinguish this component
        componentContext: 'add-action-assigned-to',
        category: this.props.category
      },
      // ⭐ Add these two properties for the sheet modal behavior ⭐
      // initialBreakpoint: 0.5,
      // breakpoints: [0, 0.5, 1],
    });

    await modal.present();
    let response = await modal.onDidDismiss();


    if (response?.data?.status == "ok") {
      this.searchUser = "";
      let res = response?.data?.data;


      this.pushNewUserToStorage(res); // this should only be worked for i discuss component but not qadd action
      this.selectedUser(res);
      this.setLastFiveDiscussedUser(res);
    } else if (response?.data?.status == "searchUser") {
      //  this.searchUserLists();
    }
    else {


    }
  }

  async searchUserLists() {

    const searchmodal = await this.modal.create({
      component: SearchUsersComponent,
      backdropDismiss: false,
      componentProps: {
        fromAction: this.props.category,
        usersValues: {},
        selectedUsers: this.selected_users
      },
      // initialBreakpoint: 0.7,
      // breakpoints: [0, 0.7, 1],
    });

    await searchmodal.present();
    let response = await searchmodal.onDidDismiss();

    if (response?.data?.status == "ok") {
      this.isSelected = true;

      let selectedUserData: any = response?.data?.data;

      this.selected_users = [];
      this.selected_users.push(selectedUserData);

      // Compute first and last names with fallback
      const firstName = selectedUserData.first_name || selectedUserData.First_Name || selectedUserData.Fname || '';
      const lastName = selectedUserData.last_name || selectedUserData.Last_Name || selectedUserData.Lname || '';
      const computedFullName = selectedUserData.Full_Name || selectedUserData.full_name || `${firstName} ${lastName}`.trim();
      
      // Update areaOwnerInfo with selected user data
      // this.areaOwnerInfo.full_name_lower = computedFullName.toLowerCase();
      this.areaOwnerInfo.Email = selectedUserData.email || selectedUserData.Email;
      this.areaOwnerInfo.id = selectedUserData.email || selectedUserData.Email;
      this.areaOwnerInfo.Full_Name = computedFullName;
      this.areaOwnerInfo.First_Name = firstName;
      this.areaOwnerInfo.Last_Name = lastName;
      this.areaOwnerInfo.Fname = firstName; // Ensure Fname is set
      this.areaOwnerInfo.Lname = lastName; // Ensure Lname is set
      this.areaOwnerInfo.assignedTo = selectedUserData.email || selectedUserData.Email;
      this.areaOwnerInfo.assignedToName = computedFullName;
      this.areaOwnerInfo.assignedToPersonUniqueId = selectedUserData.person_unique_id || selectedUserData.assignedToPersonUniqueId;

      // Update the service with the complete user object

      this.actionService.action_AreaOwner = { ...this.areaOwnerInfo };

      // Update local property to force template refresh
      this.localAreaOwner = { ...this.areaOwnerInfo };

      // Force service update by creating a new reference
      this.actionService.action_AreaOwner = Object.assign({}, this.areaOwnerInfo);

      // Force a complete service refresh
      this.actionService.action_AreaOwner = JSON.parse(JSON.stringify(this.areaOwnerInfo));
      if (this.props.category == 'add-discussed-user') {
        this.pushNewUserToStorage(this.actionService.action_AreaOwner); // this should only be worked for i discuss component but not qadd action
        this.selectedUser(this.actionService.action_AreaOwner);
        this.setLastFiveDiscussedUser(this.actionService.action_AreaOwner);
      } else {
        this.selectedUser(this.actionService.action_AreaOwner);
        this.setLastFiveAssignedUser(this.actionService.action_AreaOwner);
      }

      // Update form control using ngZone for proper binding
      this.ngZone.run(() => {
        if (this.actionService.action_AreaOwner?.Email) {
          this.formControl.setValue(this.actionService.action_AreaOwner.Email);
          this.formControl.markAsTouched();
          this.formControl.markAsDirty();
          this.formControl.updateValueAndValidity({ emitEvent: true });

          // Trigger parent form update
          if (this.form) {
            this.form.updateValueAndValidity({ emitEvent: true });
          }
        }
      });

      this.changeDetection.detectChanges();

      // Force template refresh by triggering change detection multiple times
      setTimeout(() => {
        this.changeDetection.detectChanges();

        // Force another change detection cycle
        setTimeout(() => {
          this.changeDetection.detectChanges();

          // Final check - manually trigger template update
          setTimeout(() => {
            this.changeDetection.detectChanges();

          }, 50);
        }, 50);
      }, 100);

      // console.log('User bound to action service from search:', this.actionService.action_AreaOwner);
    }
  }

  clearAreaOwner(event: Event) {
    event.stopPropagation(); // don't trigger openGADListComponent
    this.actionService.action_AreaOwner = null; // hides entire chip section
  }

  // Method to push new user to storage (copied from i-discussed-search.ts)
  async pushNewUserToStorage(new_user: any) {
    let tmp_GAD_emp_list = await this.lhStorage.get("GAD_employee_list");
    let shield_info = await this.lhStorage.get("currentRapid");
    let index = tmp_GAD_emp_list.findIndex(
      (obj: any) => obj.country == shield_info.country
    );
    tmp_GAD_emp_list[index].GAD_employee_list = [
      ...tmp_GAD_emp_list[index].GAD_employee_list,
      new_user,
    ];
    let usersList = tmp_GAD_emp_list[index].GAD_employee_list;
    tmp_GAD_emp_list[index].GAD_employee_list = usersList;
    await this.lhStorage.set("GAD_employee_list", tmp_GAD_emp_list);
    this.setGAD_Employees();
  }
  async setLastFiveAssignedUser(usr: any) {
    let lastFiveAssignedToUsers = await this.lhStorage.get(
      "lastFiveAssignedToUsers"
    );
    let userArray = lastFiveAssignedToUsers ? lastFiveAssignedToUsers : [];
    const checkIfExists = _.filter(userArray, (u: any) => {
      return u.id === usr.id;
    });
    if (userArray.length == 5) {
      if (checkIfExists.length == 0) {
        userArray.splice(0, 1);
      }
    }
    if (checkIfExists.length == 0) {
      userArray.push(usr);
    }
    let finaluserArray = _.uniqBy(userArray, "id");
    await this.lhStorage.set("lastFiveAssignedToUsers", finaluserArray);
  }
  // Method to set the last five discussed users (copied from i-discussed-search.ts)
  async setLastFiveDiscussedUser(usr: any) {
    let lastFiveDiscusedUserList = await this.lhStorage.get(
      "lastFiveIDiscussedUsers"
    );
    let userArray = lastFiveDiscusedUserList ? lastFiveDiscusedUserList : [];
    const checkIfExists = _.filter(userArray, (u: any) => {
      return u.Email === usr.Email;
    });
    if (userArray.length == 5) {
      if (checkIfExists.length == 0) {
        userArray.splice(0, 1);
      }
    }
    if (checkIfExists.length == 0) {
      userArray.push(usr);
    }
    let finaluserArray = _.uniqBy(userArray, "Email");
    await this.lhStorage.set("lastFiveIDiscussedUsers", finaluserArray);
  }

  // Method to handle user selection (copied from i-discussed-search.ts)
  selectedUser(item: any) {
    this.searchUser = "";
    this.isSelected = true;

    // 2. Normalize and compute the full name once for efficiency and consistency.
    const firstName = item.First_Name || item.first_name || item.Fname || '';
    const lastName = item.Last_Name || item.last_name || item.Lname || '';
    const computedFullName = item.Full_Name || item.full_name || `${firstName} ${lastName}`.trim();

    const userEmail = item.Email || item.id;

    // Update areaOwnerInfo with selected user data
    this.areaOwnerInfo.id = item.id;
    // this.areaOwnerInfo.full_name_lower = computedFullName.toString().toLowerCase();
    this.areaOwnerInfo.Email = userEmail;
    this.areaOwnerInfo.Full_Name = computedFullName;
    this.areaOwnerInfo.First_Name = firstName;
    this.areaOwnerInfo.Last_Name = lastName;

    // Update areaOwner with the complete user object
    this.areaOwner = { ...this.areaOwnerInfo };

    // Update the service with the complete user object
    this.actionService.action_AreaOwner = { ...this.areaOwnerInfo };

    // Update local property to force template refresh
    this.localAreaOwner = { ...this.areaOwnerInfo };

    // Update form control
    this.formControl.setValue(this.areaOwnerInfo.Email);
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();

    // Trigger change detection
    this.changeDetection.detectChanges();

    console.log('User selected and bound to service:', this.actionService.action_AreaOwner);
  }

  // Method to set GAD employees (copied from i-discussed-search.ts)
  async setGAD_Employees() {
    let tmp_GAD_emp_list = await this.lhStorage.get("GAD_employee_list");
    let shield_info = await this.lhStorage.get("currentRapid");
    let filtered = tmp_GAD_emp_list.filter(
      (obj: any) => obj.country == shield_info.country
    );
    let usersList = filtered[0].GAD_employee_list.filter(
      (obj: any) => obj.full_name_lower != undefined
    );
    this.searchUsersList = usersList.sort((a, b) =>
      a.Email.localeCompare(b.Email)
    );
    this.copyUserList = usersList.sort((a, b) =>
      a.Email.localeCompare(b.Email)
    );
  }

  //   ngOnInit(){
  //     console.log("isSelected value = " + this.isSelected);

  //   }
}
